module.exports = __webpack_public_path__ + "static/img/scheme_banner2.29650a27.png";